import React, { useRef, useEffect, useState } from 'react'
import menuTexts from '../../../../constants/staticTexts'
import { MenuDescriptionText } from '../DropdownMenu.jsx'

const DropdownRules = () => {
  return (
    <>
      <MenuDescriptionText header headerColor>
        Regulamin
      </MenuDescriptionText>
      <MenuDescriptionText>{menuTexts.menuItem.rules}</MenuDescriptionText>
    </>
  )
}

export default DropdownRules
